<template>
  <section>
    <v-container fluid grid-list-md>
      <page-title :title="userTheme == 'musei'? $t('menu.mostre') : $t('menu.news')" />
      <v-form v-if="have_news" @keyup.native.enter="search" class="mt-4">
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg2 xl1>
            <v-select v-model="searchStatus" :items="stati" :label="$t('news.stato')" />
          </v-flex>
          <v-flex xs12 sm6 md4 lg2 xl1>
            <v-select v-model="searchType" :items="setTypeSelect" :label="$t('news.tipo')" />
          </v-flex>
          <!--<v-flex v-if="$user.tenants.length > 1" xs12 sm6 md4 lg3 xl3>
            <federation-selection
              v-model="searchTenants"
              :limit="$user.tenants"
              filter
              label="Federazione"
            />
          </v-flex>-->
          <v-flex xs12 sm6 md4 lg3 xl3>
            <v-text-field v-model="q" clearable :label="$t('news.cerca')" type="text" />
          </v-flex>
          <v-flex xs12 sm6 md4 lg2 xl2>
            <v-btn
              color="primary"
              @click="search"
              :disabled="
                searchType === null &&
                searchStatus === null &&
                !q &&
                (!searchTargets || searchTargets.length === 0) &&
                (!searchTenants || searchTenants.length === 0)
              "
            >
              <v-icon>search</v-icon> {{ $t('news.cta1') }}
            </v-btn>
            <v-btn @click="resetSearch" v-if="hasSearched">
              <v-icon>undo</v-icon> {{ $t('news.ripristina') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-container v-if="have_news" fluid grid-list-md class="pt-0">
      <v-layout row wrap justify-center v-if="pagination && pagination.pageCount" class="mb-3">
        <v-pagination v-model="page" :length="pagination.pageCount"></v-pagination>
      </v-layout>
      <v-layout row wrap>
        <v-flex v-for="n in news" :key="n._id" xs12 sm6 md4 lg3 xl2>
          <!-- se è stata clonata ricarica e rileggi per prendere la nuova news -->
          <news-card :news="n" @news:cloned="$router.go()" />
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="pagination && pagination.pageCount" class="mt-3">
        <v-pagination v-model="page" :length="pagination.pageCount"></v-pagination>
      </v-layout>
    </v-container>
    <!-- <v-container v-else fluid grid-list-md class="pt-0">
      <v-card elevation="5" max-width="850px" class="ma-auto">
        <v-card-title primary-title>
          <h3 v-html="$t('news.empty.title')"></h3>
        </v-card-title>
        <v-card-text>
          <p class="mb-0" v-html="$t('news.empty.text1')"></p>
        </v-card-text>
        <v-card-text>
          <p v-html="$t('news.empty.text2')"></p>
        </v-card-text>
      </v-card>
    </v-container> -->
    <v-container v-else-if="userTheme=='musei'" grid-list-md>
      <v-card elevation="0" class="ma-auto">
        <div>
          <div class="pl-4 pr-4 pt-4 pb-2 flex-center ma-auto">
            <span class="material-symbols-outlined mr-2 f2r"> campaign </span
            ><b>{{ this.$t('nonews.one') }}</b>
          </div>
          <p class="pl-4 pr-4 pb-4">
            È facile, veloce e ti offre il modo perfetto per comunicare con il tuo pubblico e valorizzare le attività del Museo. 
            <br />
            Clicca sul pulsante rosso in fondo allo schermo e inizia a condividere notizie, eventi e mostre sul tuo sito. 
          </p>
        </div>
      </v-card>
      <div class="pb-4 pl-4 pr-4 flex-center ma-auto">
        <span class="material-symbols-outlined mr-4"> info </span>
        <span> <b>Come pubblicare una notizia, un evento sul sito?<br>Dai un'occhiata alle istruzioni o a rapidi video tutorial alla sezione <router-link to="/howto">Come fare per…</router-link> </b></span>
      </div>
    </v-container>
    <v-container v-else grid-list-md>
      <v-card elevation="0" class="ma-auto">
        <div>
          <div class="pl-4 pr-4 pt-4 pb-2 flex-center ma-auto">
            <span class="material-symbols-outlined mr-2 f2r"> campaign </span
            ><b>{{ this.$t('nonews.one') }}</b>
          </div>
          <p class="pl-4 pr-4 pb-4">
            {{ this.$t('nonews.two') }}
            <br />
            <br />
            {{ this.$t('nonews.three') }}
          </p>
        </div>
      </v-card>
      <div class="pb-4 pl-4 pr-4 flex-center ma-auto">
        <span class="material-symbols-outlined mr-4"> info </span>
        <span> <b v-html="this.$t('nonews.four')"></b></span>
      </div>
    </v-container>
    <v-tooltip left>
      <v-btn
        @click="
          $router.push({ name: 'newsItem', params: { id: 'add' }, query: { ...$route.query } })
        "
        slot="activator"
        color="error"
        fab
        fixed
        right
        bottom
        style="z-index: 20"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <span>{{ $t('news.aggiungi') }}</span>
    </v-tooltip>
  </section>
</template>

<style scoped>

.f2r {
  font-size: 2rem;
}

.br-1rem {
  border-radius: 1rem;
}

.flex-center {
  display: flex;
  align-items: center;
}
</style>

<script>
import pageTitle from '@/components/common/PageTitle';
import newsCard from '@/components/news/NewsCard';
import federationSelection from '@/components/common/FederationSelection';
import { $EventBus } from '@/eventBus';
import _union from 'lodash/union';
import _ from 'lodash';
import { $userCanEditNews } from '@/mixins/news';

export default {
  data: () => ({
    have_news: false,
    pagination: null,
    news: [],
    hasSearched: null,
    searchStatus: null,
    searchType: null,
    searchTenants: null,
    searchTargets: null,
    q: null,
    perPage: 12,
    page: 1,
    limit: 10,
    total: null,
    stati: [
      {
        text: 'Pubblicata',
        value: 1,
      },
      {
        text: 'Bozza',
        value: 0,
      },
      {
        text: 'Scaduta',
        value: -1,
      },
    ],
    tipi: [
      {
        text: 'News',
        value: 1,
      },
      {
        text: 'Eventi',
        value: 2,
      },
      {
        text: 'Seminari',
        value: 3,
      },
    ],
    tenants: null,
  }),
  mixins: [$userCanEditNews],
  watch: {
    '$route.query'(newValue, oldValue) {
      if (newValue.status !== undefined) {
        this.searchStatus = +newValue.status;
      } else {
        newValue.status = undefined;
      }
      if (newValue.tenants) {
        this.searchTenants = _.isArray(newValue.tenants) ? newValue.tenants : [+newValue.tenants];
      } else {
        this.searchTenants = [];
      }
      if (newValue.targets) {
        this.searchTargets = _.isArray(newValue.targets)
          ? newValue.targets.map((target) => target)
          : [newValue.targets];
      } else {
        this.searchTargets = [];
      }
      if (newValue.page) {
        this.page = +newValue.page;
      } else {
        this.page = 1;
      }
      this.q = newValue.q;
      this.getNews();
    },
    page(newValue, oldValue) {
      if (newValue !== +this.$route.query.page) {
        this.$router.push({ path: '/news', query: { ...this.$route.query, page: newValue } });
      }
    },
  },
  components: {
    newsCard,
    pageTitle,
    //federationSelection,
  },
  computed: {
    userTheme() {
      return this.$store.state.user.userTheme;
    },
    searchTenantsConsideringUser() {
      return this.$user.roles.indexOf('admin') === -1 && this.$user.tenants.length
        ? this.$user.tenants
        : null;
    },
    setTypeSelect() {
      if(this.$store.state.user.userTheme == 'musei') {
        const seminari = {
          text: 'Seminari',
          value: 3,
        }
        _.remove(this.tipi, seminari);
      }
      return this.tipi;
    }
  },
  methods: {
    userHaveNews() {
      for (let n of this.news) {
        if (this.$userCanEditNews(this.$user, n)) {
          // se l'utente può modificare almeno una news, mostro le news altrimenti invito l'utente a crearne una.
          this.have_news = true;
          //console.log(this.have_news, n);
          break;
        }
      }
    },
    loadMore() {
      this.getNews(true);
    },
    getNews(loadMore) {
      this.$http({
        method: 'GET',
        url: '/news/',
        params:
          {
            status: this.searchStatus,
            tenants: this.searchTenants,
            targets: this.searchTargets,
            type: this.searchType,
            q: this.q,
            page: this.page,
            limit: this.limit,
          } || {},
      })
        .then((response) => {
          this.total = response.data.total;
          this.pagination = response.data.pagination;
          if (!loadMore) {
            this.news = response.data.items; // lista
          } else {
            this.news = _union(this.news, response.data.items); // appendi
          }
          this.page = this.pagination.page;
          this.userHaveNews();
        })
        .catch((err) => {
          console.log('media get error', err);
          $EventBus.$emit('message', { type: 'error', text: this.$t('error.news.list') });
        });
    },
    resetSearch() {
      this.hasSearched = null;
      this.searchType = this.searchStatus = this.q = this.searchTargets = null; // azzera tutto
      this.searchTenants = this.searchTenantsConsideringUser; // ricerca tra i suoi
      this.$router.push({ path: '/news', query: {} });
    },
    search() {
      const searchObject = {
        q: this.q,
        page: '1',
        tenants: this.searchTenants ? this.searchTenants.map((tenant) => `${tenant}`) : undefined,
        status: this.searchStatus !== null ? `${this.searchStatus}` : undefined,
        targets: this.searchTargets ? this.searchTargets.map((target) => `${target}`) : undefined,
        type: this.searchType !== null ? `${this.searchType}` : undefined,
      };
      if (
        _.isEqual(
          _.pick(this.$route.query, ['q', 'page', 'tenants', 'status', 'targets', 'type']),
          searchObject,
        )
      ) {
        this.getNews();
      } else {
        this.$router.push({
          path: '/news',
          query: {
            ...this.$route.query,
            ...searchObject,
          },
        });
      }
      this.hasSearched = true; // per mostrare il reset
    },
  },
  mounted() {
    let tenants;
    this.$log(this.$route);
    if (this.$route.query.tenants) {
      if (_.isArray(this.$route.query.tenants)) {
        tenants = this.$route.query.tenants;
      } else {
        tenants = [+this.$route.query.tenants];
      }
    } else {
      tenants = this.searchTenantsConsideringUser;
    }

    this.searchTenants = tenants;

    if (this.$route.query.targets) {
      if (_.isArray(this.$route.query.targets)) {
        this.searchTargets = this.$route.query.targets.map((target) => +target);
      } else {
        this.searchTargets = [+this.$route.query.targets];
      }
    }
    this.q = this.$route.query.q;
    if (this.$route.query.page) {
      this.page = +this.$route.query.page;
    }
    this.searchStatus = this.$route.query.status !== undefined ? +this.$route.query.status : null;
    this.getNews();
  },
};
</script>
